import React from 'react';
import ReactDOM from 'react-dom/client';
// Mono de la linea "poster" (precios, descripciones, etiquetas). Se sirve
// desde el propio proyecto, sin depender de Google Fonts.
import '@fontsource-variable/jetbrains-mono';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
